import { render, staticRenderFns } from "./departmentFileManagement.vue?vue&type=template&id=6280df09&scoped=true"
import script from "./departmentFileManagement.vue?vue&type=script&lang=js"
export * from "./departmentFileManagement.vue?vue&type=script&lang=js"
import style0 from "./departmentFileManagement.vue?vue&type=style&index=0&id=6280df09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280df09",
  null
  
)

export default component.exports